import type { QueryClient, QueryKey } from "@tanstack/react-query";

export type QueryRefreshErrorReporter = (error: unknown) => void;

const reportQueryRefreshFailure: QueryRefreshErrorReporter = (error) => {
    console.error("Background query refresh failed after a successful mutation", error);
};

/**
 * Refreshes related reads without making a successful mutation reject when a
 * follow-up network request fails. The query keeps its own error state and the
 * failure is reported explicitly instead of being silently discarded.
 */
export function invalidateQueriesAfterMutation(
    queryClient: QueryClient,
    queryKeys: QueryKey[],
    reportError: QueryRefreshErrorReporter = reportQueryRefreshFailure
): void {
    void Promise.all(queryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))).catch(reportError);
}
